/**
 * File for initialising analytics services
 */

import { onBeforeMount, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { IAnalyticsConfig } from '../@types';

import { analyticsClickTrack } from './analytics.click.track';
import { useRoute } from 'vue-router';

export function analyticsVueInitialise () {
	const store = useStore();
	const route = useRoute();

	// Data
	const config = ref<IAnalyticsConfig[]>([]);

	// Lifecycle
	onBeforeMount(() => {
		// Reading config
		try {
			config.value = require('@/config/analytics.config').default;
		} catch (err) {
			console.warn(err);
		}

		const stateConfig: any = [];
		let version = '';

		// Get version
		try {
			version = require('@/core/modules/arguments/data/arguments.json').version;
		} catch (err) {
			console.warn(err);
		}

		// Applying analytics methods dynamically
		config.value.forEach((obj: IAnalyticsConfig) => {
			const { analytics } = obj;
			if (!analytics) { return; }
			if (obj.version && !obj.version.includes(version)) { return; }

			const configInstance: any = { ...obj };
			try {
				const analyticsMethods = require(`./type.${analytics}.analytics.ts`);
				if (analyticsMethods.initialise) {
					analyticsMethods.initialise(obj.params);
				}

				configInstance.methods = analyticsMethods;
			} catch (err) {
				console.warn(err);
			}

			stateConfig.push(configInstance);
		});
		store.dispatch('axn_updateAnalyticsConfig', stateConfig);
		initialiseSessionId();
	});

	watch(() => route.path, () => {
		analyticsClickTrack();
	});

	// Generate analytics session Id randomly
	function createSessionId () {
		const min = 1;
		const max = 9;
	
		const randomNo = () => Math.floor(Math.random() * (max - min) + min);
		return `${Date.now()}${randomNo()}`;
	}

	// Initialise Session Id
	function initialiseSessionId () {
		const userId = store.getters.get_sessionId;
		if (!userId) {
			store.dispatch('axn_updateSessionId', createSessionId());
		}
	}

	return {};
}